import React from 'react';
import { SectorPageTemplate } from '../components/SectorPageTemplate';
export function SectorHorecaHospitalityPage() {
  return <SectorPageTemplate sectorName="Horeca & Hospitality" sectorSlug="horeca-hospitality" heroTitle="Webdesign voor horeca en hospitality" heroDescription="Professionele websites voor restaurants, hotels, cafés en B&Bs. Wij bouwen websites die sfeer ademen en reserveringen genereren." whyTitle="Waarom een goede website essentieel is in de horeca" whyDescription="Gasten bepalen vaak online waar ze gaan eten of slapen. Je website moet de sfeer van je zaak perfect overbrengen." whyItems={[{
    icon: 'UtensilsIcon',
    title: 'Sfeer overbrengen',
    description: "Met grote, professionele foto's laten we bezoekers direct de sfeer van jouw zaak proeven."
  }, {
    icon: 'CalendarCheckIcon',
    title: 'Reserveringen',
    description: 'Zet websitebezoekers direct om in gasten met een naadloze reserveringsmodule.'
  }, {
    icon: 'FileTextIcon',
    title: 'Menukaart online',
    description: 'Een goed leesbare, mobielvriendelijke menukaart is de meest bezochte pagina van elke horeca-website.'
  }, {
    icon: 'SearchIcon',
    title: 'Lokale SEO',
    description: "Word gevonden door mensen die zoeken naar 'restaurant in de buurt' of 'hotel in [stad]'."
  }]} features={[{
    icon: 'CalendarCheckIcon',
    title: 'Reserveringssysteem',
    description: 'Koppeling met systemen zoals TheFork, Formitable of een eigen reserveringsmodule.'
  }, {
    icon: 'FileTextIcon',
    title: 'Online menukaart',
    description: 'Een makkelijk aanpasbare menukaart die perfect leesbaar is op mobiele telefoons.'
  }, {
    icon: 'StarIcon',
    title: 'Reviews integratie',
    description: 'Toon automatisch je beste Google of TripAdvisor reviews op je website.'
  }]} clusters={[{
    name: 'Restaurant',
    slug: 'restaurant',
    label: 'Diner',
    description: 'Sfeervolle websites voor restaurants met reserveringsmodule en menukaart.'
  }, {
    name: 'Hotel & B&B',
    slug: 'hotel-bb',
    label: 'Overnachten',
    description: "Websites voor hotels en B&B's met boekingssysteem en kameroverzicht."
  }, {
    name: 'Café & Lunchroom',
    slug: 'cafe-lunchroom',
    label: 'Horeca',
    description: 'Websites voor cafés, koffietentjes en lunchrooms.'
  }, {
    name: 'Afhaal & Bezorg',
    slug: 'afhaal-bezorg',
    label: 'Delivery',
    description: 'Websites voor afhaalrestaurants met online bestelmogelijkheid.'
  }]} faqs={[{
    q: 'Kan ik zelf de menukaart aanpassen?',
    a: "Ja, wij bouwen de website zo dat je heel eenvoudig zelf gerechten, prijzen en seizoensmenu's kunt aanpassen zonder technische kennis."
  }, {
    q: 'Koppelen jullie met TheFork of Formitable?',
    a: 'Zeker. We kunnen vrijwel elk bestaand reserveringssysteem naadloos integreren in je nieuwe website.'
  }, {
    q: 'Wat kost een website voor een restaurant?',
    a: 'Een professionele horeca-website start vanaf €1.500. Dit is inclusief het inrichten van de menukaart en het koppelen van je reserveringssysteem.'
  }, {
    q: 'Is de website goed zichtbaar op mobiel?',
    a: 'Absoluut. Meer dan 80% van de horeca-zoekopdrachten gebeurt op een mobiele telefoon. Jouw website en menukaart werken perfect op elk scherm.'
  }]} relatedPages={[{
    name: 'Website laten maken',
    href: '#/website-laten-maken'
  }, {
    name: 'SEO voor websites',
    href: '#/seo-voor-websites'
  }]} data-id="element-1881" />;
}